import React from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Container from "react-bootstrap/Container";
import Form from "react-bootstrap/Form";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import Offcanvas from "react-bootstrap/Offcanvas";
import logo from "../../Assets/logo.png";
import "./Navbar.css";
//import "bootstrap/dist/css/bootstrap.min.css";

function NavbarEK({ exact = false }) {
  const location = useLocation();

  function handleClick(e) {
    const allLinks = document.querySelectorAll(".nav-link");
    allLinks.forEach((link) => link.classList.remove("active"));
    e.target.classList.add("active");
  }

  return (
    <>
      {["lg"].map((expand) => (
        <Navbar
          key={expand}
          bg="dark"
          variant="dark"
          expand={expand}
          className="mb-3"
        >
          <Container fluid>
            <Navbar.Brand as={Link} to="/">
              {logo && (
                <img
                  title={"Home"}
                  alt="Home"
                  src={logo}
                  width="40"
                  height="40"
                  className="d-inline-block align-top"
                />
              )}
            </Navbar.Brand>
            <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            <Navbar.Offcanvas
              id={`offcanvasNavbar-expand-${expand}`}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <Navbar.Brand as={Link} to="/">
                    {logo && (
                      <img
                        title={"Home"}
                        alt="Home"
                        src={logo}
                        width="40"
                        height="40"
                        className="d-inline-block align-top"
                      />
                    )}
                  </Navbar.Brand>{" "}
                  Emisael Kisler
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                <Nav className="justify-content-end flex-grow-1 pe-3">
                  <NavLink
                    exact={exact.toString()}
                    to="/"
                    className={
                      location.pathname === "/" ? "nav-link active" : "nav-link"
                    }
                    onClick={handleClick}
                  >
                    Home
                  </NavLink>

                  <NavLink
                    exact={exact.toString()}
                    to="/about"
                    className={
                      location.pathname === "/about"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    onClick={handleClick}
                  >
                    Conóceme
                  </NavLink>

                  <NavLink
                    exact={exact.toString()}
                    to="/project"
                    className={
                      location.pathname === "/project"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    onClick={handleClick}
                  >
                    Proyectos
                  </NavLink>

                  <NavLink
                    exact={exact.toString()}
                    to="/contact"
                    className={
                      location.pathname === "/contact"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    onClick={handleClick}
                  >
                    Contáctame
                  </NavLink>

                  <NavLink
                    exact={exact.toString()}
                    to="/resume"
                    className={
                      location.pathname === "/resume"
                        ? "nav-link active"
                        : "nav-link"
                    }
                    onClick={handleClick}
                  >
                    Curriculum
                  </NavLink>

                  <NavDropdown
                    title="Despliega"
                    id={`offcanvasNavbarDropdown-expand-${expand}`}
                  >
                    <NavDropdown.Item as={Link} to="/resume">
                      Curriculum
                    </NavDropdown.Item>
                    <NavDropdown.Divider />
                    <NavDropdown.Item href="https://chatgpt-ek.vercel.app/">
                      EK-ChatGP3
                    </NavDropdown.Item>
                  </NavDropdown>
                </Nav>
                <Form className="d-flex">
                  <Form.Control
                    type="search"
                    placeholder="Search"
                    className="me-2"
                    aria-label="Search"
                  />
                  <Button variant="outline-warning">Search</Button>
                </Form>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}
    </>
  );
}

export default NavbarEK;
